import ivyStore from '@ivy/fts/ivyStore'
import showBindPhone from '@ivy/fts/showBindPhone'
import { StoreUtil } from '../commons/storage'

StoreUtil.setItem('_init_mode', 0)
export class Store {
  async login(force = false, disableOther = false) {
    return await ivyStore.login2(null, disableOther)
  }
  async bindPhone(options) {
    return await ivyStore.bindPhone(options)
  }
  async showBindPhone(redirectUrl?) {
    return await showBindPhone(redirectUrl)
  }
  async forceLogin() {
    const info = await this.login()
    if (info && info.token) {
      return
    }
    await this.showBindPhone()
  }
}

export default new Store()
